/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CaretCircleUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm41.35156,125.94531a7.997,7.997,0,0,1-11.29687-.59375L128,115.96094,97.94531,149.35156a7.99912,7.99912,0,0,1-11.89062-10.70312l36-40a8.24769,8.24769,0,0,1,11.89062,0l36,40A8.00337,8.00337,0,0,1,169.35156,149.94531Z" />
    </Svg>
  );
}

export default CaretCircleUp;
